import React, { useContext } from "react";
import PropTypes from "prop-types";
import PivotNumericUpDownPicker from "../PivotNumericUpDownPicker";
import UserLanguageContext from "../ContextWrappers/UserLanguageContext";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
  },
  contents: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
};

const PivotThermostatSetpointControls = ({
  setpointIncrement,
  setpointCoolMin,
  setpointCoolMax,
  setpointCool,
  setpointHeatMin,
  setpointHeatMax,
  setpointHeat,
  onCoolValue,
  onHeatValue,
  onChangesStarted,
  onChangesEnd,
  changeBufferMs,
  valueStyle,
  hasAriaControls,
  occuLabelStyle,
  occuLabel,
}) => {
  const valuesRegionId = "nx-components_ThermostatSetpoints_values";
  const languageContext = useContext(UserLanguageContext);
  const language =
    languageContext.localeSet.nx_components.PivotThermostatSetpointControls;

  return (
    <div style={styles.container}>
      <span
        style={{
          ...styles.contents,
          ...occuLabelStyle,
        }}
      >
        {occuLabel}
      </span>
      <div style={styles.contents}>
        <PivotNumericUpDownPicker
          label={`${language.heatTo}:`}
          unit="°"
          step={setpointIncrement}
          min={setpointHeatMin}
          max={setpointHeatMax}
          value={setpointHeat}
          onValue={onHeatValue}
          onChangesStarted={onChangesStarted}
          onChangesEnded={onChangesEnd}
          changeBufferMs={changeBufferMs}
          valueStyle={valueStyle}
          isHeat
          aria-controls={hasAriaControls ? valuesRegionId : undefined}
        />
        <PivotNumericUpDownPicker
          label={`${language.coolTo}:`}
          unit="°"
          step={setpointIncrement}
          min={setpointCoolMin}
          max={setpointCoolMax}
          value={setpointCool}
          onValue={onCoolValue}
          onChangesStarted={onChangesStarted}
          onChangesEnded={onChangesEnd}
          changeBufferMs={changeBufferMs}
          valueStyle={valueStyle}
          isCool
          aria-controls={hasAriaControls ? valuesRegionId : undefined}
        />
      </div>
    </div>
  );
};

PivotThermostatSetpointControls.propTypes = {
  setpointIncrement: PropTypes.number,
  setpointCoolMin: PropTypes.number,
  setpointCoolMax: PropTypes.number,
  setpointCool: PropTypes.number,
  setpointHeatMin: PropTypes.number,
  setpointHeatMax: PropTypes.number,
  setpointHeat: PropTypes.number,
  onCoolValue: PropTypes.func,
  onHeatValue: PropTypes.func,
  onChangesStarted: PropTypes.func,
  onChangesEnd: PropTypes.func,
  changeBufferMs: PropTypes.number,
  valueStyle: PropTypes.object,
  hasAriaControls: PropTypes.bool,
  occuLabelStyle: PropTypes.object,
  occuLabel: PropTypes.string,
};

export default PivotThermostatSetpointControls;



// WEBPACK FOOTER //
// ../nx-components/src/Thermostat/PivotThermostatSetpointControls.jsx